import React, { useContext } from "react";
import "./StartupProjects.scss";
import { projects } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import { Link, useHistory } from 'react-router-dom';
import Button from "../../components/button/Button";
import { Box } from "@material-ui/core";

export default function StartupProject() {
  const history = useHistory();
  const sliced = projects.projects.slice(0, 3)

  const handleClick = (id) => {
    history.push(`/project/${id}`)
  };

  const { isDark } = useContext(StyleContext);
  if (!projects.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <div>
          <h1 className="skills-heading">{projects.titleHome}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {projects.subtitle}
          </p>

          <div className="projects-container">
            {sliced.map((project, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode project-card project-card-dark"
                      : "project-card project-card-light"
                  }
                >
                  {project.image ? (
                    <div className="project-image">
                      <img
                        src={project.image}
                        alt={project.projectName}
                        className="card-image"
                      ></img>
                    </div>
                  ) : null}
                  <div className="project-detail">
                    <h5
                      className={isDark ? "dark-mode card-title" : "card-title"}
                    >
                      {project.projectName}
                    </h5>
                    <p
                      className={
                        isDark ? "dark-mode card-subtitle" : "card-subtitle"
                      }
                    >
                      {project.projectDesc}
                    </p>
                    <div className="project-card-footer">
                      <span className={
                        isDark ? "dark-mode project-tag" : "project-tag"
                      } onClick={() => handleClick(project._id)}>View Details</span>
                    </div>

                    {/* {project.footerLink ? (
                      <div className="project-card-footer">
                        {project.footerLink.map((link, i) => {
                          return (
                            <span
                              key={i}
                              className={
                                isDark ? "dark-mode project-tag" : "project-tag"
                              }
                              onClick={() => handleClickOpen()}
                            >
                              {link.name}
                            </span>
                          );
                        })}
                      </div>
                    ) : null} */}
                  </div>
                </div>
              );
            })}

          </div>
          <Box style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }} >
            <Link to="/projects" style={{ textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>
              <Button text="Explore More Projects" />
            </Link>
          </Box>
        </div>
      </div>

    </Fade>
  );
}
